enum OrganisationRoleEnum {
    Customer = 1,
    DesignCustomer,
    GeneralContractor,
    GeneralDesigner,
    Subcontractor,
}

export default OrganisationRoleEnum;
